import React from 'react';
import { Card, CardContent } from '@tmap/mmm-style-guide/src/Card';
import { List, ListItem, ListItemText } from '@tmap/mmm-style-guide/src/List';
import { Hyperlink } from '@tmap/mmm-style-guide/src/Hyperlink';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { ArrowForwardIos } from '@tmap/mmm-style-guide/src/Icon';
import { Divider } from '@tmap/mmm-style-guide/src/Divider';
import { topics } from '@tmap/mmm-core/contributionTopics';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';

const ArrowIcon = styled(ArrowForwardIos)(({ theme }) => ({
  color: theme.palette.action.active,
  marginTop: theme.spacing(1),
  fontSize: '16px',
}));

const TopicListItem = styled(ListItem)(({ theme }) => ({
  color: theme.palette.secondary.main,
  '& .MuiTypography-root': { fontWeight: 600 },
}))

const StyledDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(0, 2),
}))

const SuggestedTopicsCard = ({ suggestedTopics, communityUrl }) => {
  return (
    <Card elevation={2} sx={{ height: '100%', borderRadius: '8px' }}>
      <CardContent sx={{ px: 2.75, pt: 4, pb: 5 }}>
        <Typography textAlign='center' color='primary.veryDark' fontSize='18px' mb={3}>
          <Typography component='span' fontWeight={600} fontSize='18px'>Similar Categories</Typography>
          <br />
          you may be interested in
        </Typography>
        <List sx={{ width: '100%' }}>
          {suggestedTopics.map((topic, i) => (
            <React.Fragment key={`suggested-topic-${topic._id}`}>
              <TopicListItem
                component={Hyperlink}
                href={`${communityUrl}/${topic._id.toLowerCase().replace('#', '')}`}
                key={`suggested-topic-link-${topic._id}`}
                secondaryAction={<ArrowIcon />}
              >
                <ListItemText primary={topics[topic._id]?.plural || topic._id} />
              </TopicListItem>
              {(i < suggestedTopics.length - 1) && <StyledDivider />}
            </React.Fragment>
          ))}
        </List>
      </CardContent>
    </Card>
  )
}

export default SuggestedTopicsCard;